export const ENV = import.meta.env.MODE;
export const CLIENT_SECRET = import.meta.env.VITE_CLIENT_SECRET;
export const CLIENT_ID = import.meta.env.VITE_CLIENT_ID;
export const GRANT_TYPE = import.meta.env.VITE_GRANT_TYPE;
export const API_URL = import.meta.env.VITE_API_URL;
export const SECRET_KEY = import.meta.env.VITE_SECRET_KEY;
export const REFRESH_TOKEN_TYPE = import.meta.env.VITE_REFRESH_TOKEN_TYPE;
export const DISABLE_BUTTON_FLAG = import.meta.env.VITE_DISABLE_BUTTON_FLAG?.toLowerCase() === 'true';

export const booleanOptions: Inputs.SelectOption[] = [
  { value: 1, label: 'Yes' },
  { value: 0, label: 'No' },
];

export const defaultFilterData: CapBayGetParams = {
  currentPage: 1,
  pageSize: 10,
};

export enum PaymentApproval {
  Approve = 1,
  Reject = 0,
}

export const tempEmptyData = { data: [], totalFiltered: 0, totalAmount: 0 };

export enum CapBayNumberBoolean {
  True = 1,
  False = 0,
}

export enum CapBayStringBoolean {
  True = '1',
  False = '0',
}

export enum CapBayYesNo {
  Yes = 'Yes',
  No = 'No',
}

export enum ProfitApproval {
  Approve = 'approve',
  Reject = 'reject',
}

export enum StatementTypeId {
  AnnualStatement = 1,
  QuarterlyStatement = 2,
  TaxStatement = 3,
  MonthlyReport = 4,
  InstitutionalInvestorMonthlyStatement = 5,
}

export enum WithdrawalReason {
  Other = 9,
}

export enum InputMask {
  IC = '000000-00-0000',
}

export enum FileMimeType {
  EXCEL = 'application/vnd.ms-excel',
}

export enum ProgrammeType {
  DealerFinancing = 7,
  InventoryFinancing = 9,
}

export enum InvestmentNoteGrading {
  APlusAssure = 1,
}

export enum CapbayTheme {
  ASSURE = 4,
}

export enum SpecialAllocationRequirement {
  SPECIFIC_BUYER_SUPPLIERS = 1,
  ISLAMIC_FINANCING_TYPES = 2,
  MSME = 3,
}

export enum InternalFunderType {
  ISLAMIC_NOTES = 'Islamic Notes',
}

export enum ServiceFeeRebateTypes {
  ON_INVESTOR = 1,
  ON_INVESTMENT_NOTE = 2,
}

export enum ProductTypes {
  INVOICE = 1,
  TERM_LOAN = 2,
}

export enum PurposeOfTransactions {
  INVESTMENTS = '1',
  OTHERS = '2',
}

export enum SanctionUserApproval {
  APPROVE = 1,
  REJECT = 0,
}

export enum SanctionUserStatuses {
  APPROVED = 'Approved',
  BLOCKED = 'Blocked',
  BLOCKED_BY_SYSTEM = 'Blocked by System',
  PENDING = 'Pending',
}

export const iCRPDisabledColumns: string[] = [
  'identification_type',
  'identification_no',
  'rca',
  'type_of_investor',
  'annual_employment_income',
  'company_name',
  'employment_status',
  'employment_title',
  'interested_investment_amount',
  'job_category',
  'nationality',
  'net_worth',
  'pep_status',
];

export enum SpecialAllocationInvestorCategories {
  CAPBAY_BUSINESS = 2,
  CORPORATE = 3,
  SPECIAL_COPERATE = 10,
  MYCIF = 12,
}

export enum QuestionsDidYouFindUs {
  OTHERS = 8,
  BILLBOARD = 12,
  EVENTS = 15,
  GOOGLE = 26,
  SOCIAL_MEDIA_OPTIONS = 27,
  LINKEDIN = 28,
  EMAIL_NEWSLETTER = 29,
  FRIENDS = 30,
  PODCAST_YOUTUBE = 31,
  WEBINAR = 32,
}

export enum Country {
  Malaysia = 1,
}

export enum IDType {
  GOVERNMENT_ISSUED_ID = 1,
  PASSPORT = 2,
  COMPANY_ID = 3,
}

export enum Gender {
  MALE = 'M',
  FEMALE = 'F',
  NOT_AVAILABLE = 'NA',
}

export enum AutoInvestTenureLimitId {
  THREE_MONTHS = 1,
  SIX_MONTHS = 2,
  TWELVE_MONTHS = 3,
  TWENTY_FOUR_MONTHS = 4,
  MORE_THAN_TWENTY_FOUR_MONTHS = 5,
}
